<div class="text-dark text-base flex items-center gap-x-2">
    <div *ngFor="let item of path" class="inline-flex gap-2 font-normal" (click)="nodeTapped.next(item)">
        <span class="text-ellipsis overflow-hidden whitespace-nowrap">{{ item.name }}</span>
        <span>/</span>
    </div>
    <div class="font-medium text-ellipsis overflow-hidden whitespace-nowrap">{{ current }}</div>
</div>
